import request from "@/utils/oms-request";

export const queryAllNumberTypes = () =>
    request({
      url: "/number_types",
      method: "GET"
    })